import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Global scroll-to-top on route change. Mounted once inside the Router.
// Resets window + primary page-scroll container, honours hash anchors, and
// moves focus to the main content region for accessibility.
export default function ScrollToTop() {
  const { pathname, hash, search } = useLocation();
  const navigationType = useNavigationType();
  const page = new URLSearchParams(search).get("page") || "";

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    // Valid same-page anchor: scroll the target into view instead of the top.
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const el = id && document.getElementById(id);
      if (el) {
        const frame = window.requestAnimationFrame(() =>
          el.scrollIntoView({ behavior: "auto", block: "start" })
        );
        return () => window.cancelAnimationFrame(frame);
      }
    }

    const frame = window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      const container = document.querySelector("[data-page-scroll-container]");
      if (container && typeof container.scrollTo === "function") {
        container.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }
      const main = document.getElementById("main-content");
      if (main) {
        try { main.focus({ preventScroll: true }); } catch { /* noop */ }
      }
    });
    return () => window.cancelAnimationFrame(frame);
    // Reset on real page changes (pathname) and result-page changes (?page).
  }, [pathname, page, hash, navigationType]);

  return null;
}
